import { BaseService } from "./common/base";
import type { InventoryItem } from "../../../../api/src/inventory/entities/inventory-item.entity";

export class InventoryService extends BaseService<InventoryItem> {
  constructor() {
    super("inventory");
  }

  public createItem(data: {
    name: string;
    baseUnit: string;
  }): Promise<InventoryItem> {
    return this._post("/items", data);
  }

  public findItems(): Promise<InventoryItem[]> {
    return this._get("/items");
  }

  public getItem(id: string): Promise<InventoryItem> {
    return this._get(`/items/${id}`);
  }

  public updateItem(
    id: string,
    data: {
      name: string;
      baseUnit: string;
    }
  ): Promise<InventoryItem> {
    return this._put(`/items/${id}`, data);
  }

  public getSupplyRequest(id: string): Promise<unknown> {
    return this._get(`/supply-requests/${id}`);
  }
}
